<template>
  <div class="sid-select">
    <SidbearSettingsGroup
      title="Menu Links"
      :active="showActiveGroup"
    >
      <b-form-group v-if="linked && !subjectHide.includes('unlink')">
        <button
          class="flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]"
          @click="() => unlinkSid()"
        >
          Unlink Styles
          <i class="fa fa-link text-primary" />
        </button>
      </b-form-group>
      
      <b-form-group label="Menu Items">
        <button
          class="flex w-100 items-center border rounded-[3px] font-[600] text-[#44474A] text-[14px] h-[38px] px-[17px] shadow-[0_2px_3px_rgba(0, 0, 0, 0.06)] mb-2"
          @click="navigationModal = true"
        >
          <svg
            class="mr-[10px]"
            fill="none"
            height="12"
            viewBox="0 0 14 12"
            width="14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.28033 0.21967C7.98744 -0.0732233 7.51256 -0.0732233 7.21967 0.21967C6.92678 0.512563 6.92678 0.987437 7.21967 1.28033L11.1893 5.25H1C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75H11.1893L7.21967 10.7197C6.92678 11.0126 6.92678 11.4874 7.21967 11.7803C7.51256 12.0732 7.98744 12.0732 8.28033 11.7803L13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.28033 0.21967Z"
              fill="#3D82EA"
            />
          </svg>

          Go to Navigation
        </button>
      </b-form-group>

      <rule-tabs :tabs="['Normal', 'Hover', 'Active']">
        <template #Normal>
          <sid-font
            :sid="`.--${section.sid}--wrapper`"
          />

          <b-form-group>
            <div class="flex justify-between">
              <label class="pb-0">Link Color</label>

              <sid-color
                :sid="`.--${section.sid}--link`"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex justify-between">
              <label class="pb-0">Icon Color</label>

              <sid-color
                :sid="`.--${section.sid}--link .--${section.sid}--icon`"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-range-slider
            label="Font Size"
            :sid="`.--${section.sid}--link`"
            rule-name="font-size"
          />

          <sid-flex-direction
            :sid="`.--${section.sid}--wrapper`"
            rule-name="flex-direction"
          />

          <sid-buttons-group
            label="Alignment"
            :options="[
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'10.04\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 10.04 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'5.54224\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 5.54224 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.5555\' height=\'0.91364\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.913574 14.5557)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'start',
                tooltip: 'Start'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'3.9668\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 3.9668 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'10.4326\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 10.4326 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.3631\' height=\'0.901561\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 5.59766 14.363)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'center',
                tooltip: 'Center'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'16\' viewBox=\'0 0 11 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 0 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 4.7002 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'9.53613\' y=\'16\' width=\'15.2079\' height=\'0.95459\' transform=\'rotate(-90 9.53613 16)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'end',
                tooltip: 'End'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'14\' height=\'13\' viewBox=\'0 0 14 13\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'3.02612\' height=\'8.41616\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 4.4834 2.28711)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'3.02612\' height=\'8.41616\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 11.7031 2.28711)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'11.1734\' height=\'0.701346\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.701172 12.0225)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'11.1734\' height=\'0.701346\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 13.1602 12.0225)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'space-between',
                tooltip: 'Between'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'13\' height=\'14\' viewBox=\'0 0 13 14\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'3.26467\' height=\'9.07958\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 5.48535 2.51978)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'3.26467\' height=\'9.07958\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 10.0303 2.51978)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'12.0541\' height=\'0.756631\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.756836 13.0225)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'12.0541\' height=\'0.756631\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 12.25 13.0225)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'space-around',
                tooltip: 'Around'
              }
            ]"
            :sid="`.--${section.sid}--wrapper`"
            rule-name="justify-content"
            var="align-items"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="p-0">Font Style</label>

              <sid-font-style
                :sid="`.--${section.sid}--link`"
                rule-name="font"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="p-0">Text Transform</label>

              <sid-buttons-group
                class="mb-0"
                :options="[
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'21\' height=\'12\' viewBox=\'0 0 21 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 8.22656L4.75781 4.52344H4.625L3.17969 8.22656H6.28906ZM0.289062 11.5938C0.674479 11.5677 0.984375 11.3932 1.21875 11.0703C1.36979 10.8672 1.58594 10.4193 1.86719 9.72656L5.42188 0.96875H5.86719L9.4375 9.375C9.83854 10.3177 10.138 10.9271 10.3359 11.2031C10.5339 11.474 10.8151 11.6042 11.1797 11.5938V12H6V11.5938C6.52083 11.5729 6.86198 11.5286 7.02344 11.4609C7.1901 11.3932 7.27344 11.2214 7.27344 10.9453C7.27344 10.8203 7.23177 10.6302 7.14844 10.375C7.09635 10.224 7.02604 10.0417 6.9375 9.82812L6.53125 8.85938H2.9375C2.70312 9.49479 2.55208 9.90885 2.48438 10.1016C2.34375 10.513 2.27344 10.8125 2.27344 11C2.27344 11.2292 2.42708 11.3958 2.73438 11.5C2.91667 11.5573 3.1901 11.5885 3.55469 11.5938V12H0.289062V11.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.2578 11.5938C11.6901 11.5781 12 11.5208 12.1875 11.4219C12.5052 11.2552 12.6641 10.9375 12.6641 10.4688V2.72656C12.6641 2.25781 12.5156 1.94271 12.2188 1.78125C12.0417 1.68229 11.7214 1.61979 11.2578 1.59375V1.1875H16.2031C17.1562 1.1875 17.9479 1.29688 18.5781 1.51562C19.7656 1.92708 20.3594 2.67708 20.3594 3.76562C20.3594 4.42708 20.1172 4.95312 19.6328 5.34375C19.1536 5.72917 18.6328 5.97396 18.0703 6.07812V6.22656C18.6641 6.34115 19.1797 6.53385 19.6172 6.80469C20.4714 7.33594 20.8984 8.07552 20.8984 9.02344C20.8984 9.90885 20.4896 10.6276 19.6719 11.1797C18.8542 11.7266 17.7656 12 16.4062 12H11.2578V11.5938ZM15.2188 6.03906C16.2083 6.03906 16.8724 5.8776 17.2109 5.55469C17.5495 5.23177 17.7188 4.65885 17.7188 3.83594C17.7188 3.22656 17.6068 2.71354 17.3828 2.29688C17.1641 1.88021 16.7396 1.67188 16.1094 1.67188C15.776 1.67188 15.5443 1.72917 15.4141 1.84375C15.2839 1.95312 15.2188 2.15365 15.2188 2.44531V6.03906ZM15.2188 10.5234C15.224 10.8047 15.2656 11.0104 15.3438 11.1406C15.474 11.3698 15.724 11.4844 16.0938 11.4844C16.849 11.4844 17.3776 11.2786 17.6797 10.8672C17.987 10.4557 18.1406 9.86979 18.1406 9.10938C18.1406 7.97396 17.8047 7.21875 17.1328 6.84375C16.7266 6.61458 16.0885 6.50781 15.2188 6.52344V10.5234Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                    value: 'uppercase',
                    tooltip: 'Uppercase'
                  },
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'20\' height=\'18\' viewBox=\'0 0 20 18\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 10.2266L4.75781 6.52344H4.625L3.17969 10.2266H6.28906ZM0.289062 13.5938C0.674479 13.5677 0.984375 13.3932 1.21875 13.0703C1.36979 12.8672 1.58594 12.4193 1.86719 11.7266L5.42188 2.96875H5.86719L9.4375 11.375C9.83854 12.3177 10.138 12.9271 10.3359 13.2031C10.5339 13.474 10.8151 13.6042 11.1797 13.5938V14H6V13.5938C6.52083 13.5729 6.86198 13.5286 7.02344 13.4609C7.1901 13.3932 7.27344 13.2214 7.27344 12.9453C7.27344 12.8203 7.23177 12.6302 7.14844 12.375C7.09635 12.224 7.02604 12.0417 6.9375 11.8281L6.53125 10.8594H2.9375C2.70312 11.4948 2.55208 11.9089 2.48438 12.1016C2.34375 12.513 2.27344 12.8125 2.27344 13C2.27344 13.2292 2.42708 13.3958 2.73438 13.5C2.91667 13.5573 3.1901 13.5885 3.55469 13.5938V14H0.289062V13.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M14.3672 12.4453C14.388 12.737 14.4453 12.9766 14.5391 13.1641C14.7266 13.5286 15.0391 13.7109 15.4766 13.7109C16.0234 13.7109 16.4089 13.4219 16.6328 12.8438C16.862 12.2656 16.9766 11.4479 16.9766 10.3906C16.9766 9.55208 16.875 8.83073 16.6719 8.22656C16.474 7.6224 16.0833 7.32031 15.5 7.32031C15.1562 7.32031 14.8802 7.44792 14.6719 7.70312C14.4688 7.95312 14.3672 8.13281 14.3672 8.24219V12.4453ZM14.3672 3.1875V7.33594C14.6172 7.09115 14.849 6.90625 15.0625 6.78125C15.4531 6.55729 15.875 6.44531 16.3281 6.44531C17.2292 6.44531 17.9531 6.79688 18.5 7.5C19.0521 8.20312 19.3281 9.06771 19.3281 10.0938C19.3281 11.4167 18.9766 12.4375 18.2734 13.1562C17.5755 13.8698 16.7057 14.2266 15.6641 14.2266C15.237 14.2266 14.8594 14.1432 14.5312 13.9766C14.2031 13.8099 13.8958 13.5911 13.6094 13.3203L12.3516 14.2266H12.125V4.5C12.125 4.16667 12.0651 3.94271 11.9453 3.82812C11.8255 3.70833 11.6016 3.625 11.2734 3.57812V3.1875H14.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                    value: 'capitalize',
                    tooltip: 'Capitalize'
                  },
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'17\' height=\'12\' viewBox=\'0 0 17 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M3.50781 10.0859C3.76823 10.0859 4.01042 10.0078 4.23438 9.85156C4.35938 9.75781 4.50781 9.61198 4.67969 9.41406V7.07812C4.2526 7.18229 3.8776 7.34635 3.55469 7.57031C3.00781 7.95052 2.73438 8.4349 2.73438 9.02344C2.73438 9.3724 2.8125 9.63802 2.96875 9.82031C3.13021 9.9974 3.3099 10.0859 3.50781 10.0859ZM0.40625 9.50781C0.40625 8.78906 0.752604 8.21875 1.44531 7.79688C2.13802 7.375 3.22396 6.95052 4.70312 6.52344V5.35938C4.70312 4.88542 4.60156 4.53646 4.39844 4.3125C4.20052 4.08333 3.84635 3.96875 3.33594 3.96875C3.04948 3.96875 2.8125 4.02344 2.625 4.13281C2.44271 4.23698 2.35156 4.36979 2.35156 4.53125C2.35156 4.59375 2.36198 4.64583 2.38281 4.6875C2.40365 4.72917 2.4349 4.77344 2.47656 4.82031L2.57031 4.92969C2.64323 5.01823 2.70052 5.11719 2.74219 5.22656C2.78906 5.33073 2.8125 5.44271 2.8125 5.5625C2.8125 5.86458 2.71094 6.09896 2.50781 6.26562C2.3099 6.42708 2.07812 6.50781 1.8125 6.50781C1.50521 6.50781 1.24219 6.41667 1.02344 6.23438C0.809896 6.05208 0.703125 5.78906 0.703125 5.44531C0.703125 4.83073 0.992188 4.34375 1.57031 3.98438C2.14844 3.625 2.85938 3.44531 3.70312 3.44531C4.60938 3.44531 5.36719 3.61979 5.97656 3.96875C6.58073 4.32292 6.88281 4.97396 6.88281 5.92188V9.79688C6.88281 9.91146 6.91146 10.0104 6.96875 10.0938C7.03125 10.1719 7.09896 10.2109 7.17188 10.2109C7.23438 10.2109 7.28906 10.2005 7.33594 10.1797C7.38802 10.1536 7.46615 10.0885 7.57031 9.98438L7.8125 10.3203C7.5 10.6849 7.15365 10.9401 6.77344 11.0859C6.53385 11.1797 6.28125 11.2266 6.01562 11.2266C5.54167 11.2266 5.19531 11.0885 4.97656 10.8125C4.85156 10.6562 4.76042 10.4245 4.70312 10.1172C4.26042 10.5599 3.76042 10.8724 3.20312 11.0547C2.86458 11.1693 2.53125 11.2266 2.20312 11.2266C1.76562 11.2266 1.35677 11.0885 0.976562 10.8125C0.596354 10.5312 0.40625 10.0964 0.40625 9.50781Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.3672 9.44531C11.388 9.73698 11.4453 9.97656 11.5391 10.1641C11.7266 10.5286 12.0391 10.7109 12.4766 10.7109C13.0234 10.7109 13.4089 10.4219 13.6328 9.84375C13.862 9.26562 13.9766 8.44792 13.9766 7.39062C13.9766 6.55208 13.875 5.83073 13.6719 5.22656C13.474 4.6224 13.0833 4.32031 12.5 4.32031C12.1562 4.32031 11.8802 4.44792 11.6719 4.70312C11.4688 4.95312 11.3672 5.13281 11.3672 5.24219V9.44531ZM11.3672 0.1875V4.33594C11.6172 4.09115 11.849 3.90625 12.0625 3.78125C12.4531 3.55729 12.875 3.44531 13.3281 3.44531C14.2292 3.44531 14.9531 3.79688 15.5 4.5C16.0521 5.20312 16.3281 6.06771 16.3281 7.09375C16.3281 8.41667 15.9766 9.4375 15.2734 10.1562C14.5755 10.8698 13.7057 11.2266 12.6641 11.2266C12.237 11.2266 11.8594 11.1432 11.5312 10.9766C11.2031 10.8099 10.8958 10.5911 10.6094 10.3203L9.35156 11.2266H9.125V1.5C9.125 1.16667 9.0651 0.942708 8.94531 0.828125C8.82552 0.708333 8.60156 0.625 8.27344 0.578125V0.1875H11.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                    value: 'lowercase',
                    tooltip: 'Lowercase'
                  }
                ]"
                :sid="`.--${section.sid}--link`"
                rule-name="text-transform"
              />
            </div>
          </b-form-group>

          <sid-range-slider
            label="Line Height"
            rule-name="line-height"
            :sid="`.--${section.sid}--link`"
          />

          <sid-range-slider
            label="Letter Spacing"
            rule-name="letter-spacing"
            :sid="`.--${section.sid}--link`"
          />

          <sid-range-slider
            label="Gap"
            rule-name="gap"
            :sid="`.--${section.sid}--wrapper`"
          />

          <sid-background
            :sid="`.--${section.sid}--wrapper`"
          />

          <sid-background
            label="Link Background Color"
            :sid="`.--${section.sid}--link`"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Link Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--link`"
                rule-name="border-style"
                :searchable="false"
                class="w-[118px]"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--link`"
              label="Link Border Width"
              rule-name="border"
              class="!mb-[7px]"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--link`"
                rule-name="border-color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Link Border Radius"
            :sid="`.--${section.sid}--link`"
            rule-name="border"
            :angles="[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]"
          />

          <sid-linked-group
            label="Link Padding"
            :sid="`.--${section.sid}--link`"
            rule-name="padding"
            :min="0"
            :angles="[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]"
          />
        </template>

        <template #Hover>
          <sid-font
            :sid="`.--${section.sid}--link`"
            presudo=":hover"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Link Color</label>

              <sid-color
                :sid="`.--${section.sid}--link`"
                presudo=":hover"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex justify-between">
              <label class="pb-0">Icon Color</label>

              <sid-color
                :sid="`.--${section.sid}--link .--${section.sid}--icon`"
                presudo=":hover"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-range-slider
            label="Font Size"
            :sid="`.--${section.sid}--link`"
            rule-name="font-size"
            presudo=":hover"
          />

          <b-form-group>
            <sid-font-style
              :sid="`.--${section.sid}--link`"
              rule-name="font"
              presudo=":hover"
            />
          </b-form-group>

          <sid-buttons-group
            label="Text Transform"
            presudo=":hover"
            :options="[
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'21\' height=\'12\' viewBox=\'0 0 21 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 8.22656L4.75781 4.52344H4.625L3.17969 8.22656H6.28906ZM0.289062 11.5938C0.674479 11.5677 0.984375 11.3932 1.21875 11.0703C1.36979 10.8672 1.58594 10.4193 1.86719 9.72656L5.42188 0.96875H5.86719L9.4375 9.375C9.83854 10.3177 10.138 10.9271 10.3359 11.2031C10.5339 11.474 10.8151 11.6042 11.1797 11.5938V12H6V11.5938C6.52083 11.5729 6.86198 11.5286 7.02344 11.4609C7.1901 11.3932 7.27344 11.2214 7.27344 10.9453C7.27344 10.8203 7.23177 10.6302 7.14844 10.375C7.09635 10.224 7.02604 10.0417 6.9375 9.82812L6.53125 8.85938H2.9375C2.70312 9.49479 2.55208 9.90885 2.48438 10.1016C2.34375 10.513 2.27344 10.8125 2.27344 11C2.27344 11.2292 2.42708 11.3958 2.73438 11.5C2.91667 11.5573 3.1901 11.5885 3.55469 11.5938V12H0.289062V11.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.2578 11.5938C11.6901 11.5781 12 11.5208 12.1875 11.4219C12.5052 11.2552 12.6641 10.9375 12.6641 10.4688V2.72656C12.6641 2.25781 12.5156 1.94271 12.2188 1.78125C12.0417 1.68229 11.7214 1.61979 11.2578 1.59375V1.1875H16.2031C17.1562 1.1875 17.9479 1.29688 18.5781 1.51562C19.7656 1.92708 20.3594 2.67708 20.3594 3.76562C20.3594 4.42708 20.1172 4.95312 19.6328 5.34375C19.1536 5.72917 18.6328 5.97396 18.0703 6.07812V6.22656C18.6641 6.34115 19.1797 6.53385 19.6172 6.80469C20.4714 7.33594 20.8984 8.07552 20.8984 9.02344C20.8984 9.90885 20.4896 10.6276 19.6719 11.1797C18.8542 11.7266 17.7656 12 16.4062 12H11.2578V11.5938ZM15.2188 6.03906C16.2083 6.03906 16.8724 5.8776 17.2109 5.55469C17.5495 5.23177 17.7188 4.65885 17.7188 3.83594C17.7188 3.22656 17.6068 2.71354 17.3828 2.29688C17.1641 1.88021 16.7396 1.67188 16.1094 1.67188C15.776 1.67188 15.5443 1.72917 15.4141 1.84375C15.2839 1.95312 15.2188 2.15365 15.2188 2.44531V6.03906ZM15.2188 10.5234C15.224 10.8047 15.2656 11.0104 15.3438 11.1406C15.474 11.3698 15.724 11.4844 16.0938 11.4844C16.849 11.4844 17.3776 11.2786 17.6797 10.8672C17.987 10.4557 18.1406 9.86979 18.1406 9.10938C18.1406 7.97396 17.8047 7.21875 17.1328 6.84375C16.7266 6.61458 16.0885 6.50781 15.2188 6.52344V10.5234Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'uppercase',
                tooltip: 'Uppercase'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'20\' height=\'18\' viewBox=\'0 0 20 18\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 10.2266L4.75781 6.52344H4.625L3.17969 10.2266H6.28906ZM0.289062 13.5938C0.674479 13.5677 0.984375 13.3932 1.21875 13.0703C1.36979 12.8672 1.58594 12.4193 1.86719 11.7266L5.42188 2.96875H5.86719L9.4375 11.375C9.83854 12.3177 10.138 12.9271 10.3359 13.2031C10.5339 13.474 10.8151 13.6042 11.1797 13.5938V14H6V13.5938C6.52083 13.5729 6.86198 13.5286 7.02344 13.4609C7.1901 13.3932 7.27344 13.2214 7.27344 12.9453C7.27344 12.8203 7.23177 12.6302 7.14844 12.375C7.09635 12.224 7.02604 12.0417 6.9375 11.8281L6.53125 10.8594H2.9375C2.70312 11.4948 2.55208 11.9089 2.48438 12.1016C2.34375 12.513 2.27344 12.8125 2.27344 13C2.27344 13.2292 2.42708 13.3958 2.73438 13.5C2.91667 13.5573 3.1901 13.5885 3.55469 13.5938V14H0.289062V13.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M14.3672 12.4453C14.388 12.737 14.4453 12.9766 14.5391 13.1641C14.7266 13.5286 15.0391 13.7109 15.4766 13.7109C16.0234 13.7109 16.4089 13.4219 16.6328 12.8438C16.862 12.2656 16.9766 11.4479 16.9766 10.3906C16.9766 9.55208 16.875 8.83073 16.6719 8.22656C16.474 7.6224 16.0833 7.32031 15.5 7.32031C15.1562 7.32031 14.8802 7.44792 14.6719 7.70312C14.4688 7.95312 14.3672 8.13281 14.3672 8.24219V12.4453ZM14.3672 3.1875V7.33594C14.6172 7.09115 14.849 6.90625 15.0625 6.78125C15.4531 6.55729 15.875 6.44531 16.3281 6.44531C17.2292 6.44531 17.9531 6.79688 18.5 7.5C19.0521 8.20312 19.3281 9.06771 19.3281 10.0938C19.3281 11.4167 18.9766 12.4375 18.2734 13.1562C17.5755 13.8698 16.7057 14.2266 15.6641 14.2266C15.237 14.2266 14.8594 14.1432 14.5312 13.9766C14.2031 13.8099 13.8958 13.5911 13.6094 13.3203L12.3516 14.2266H12.125V4.5C12.125 4.16667 12.0651 3.94271 11.9453 3.82812C11.8255 3.70833 11.6016 3.625 11.2734 3.57812V3.1875H14.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'capitalize',
                tooltip: 'Capitalize'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'17\' height=\'12\' viewBox=\'0 0 17 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M3.50781 10.0859C3.76823 10.0859 4.01042 10.0078 4.23438 9.85156C4.35938 9.75781 4.50781 9.61198 4.67969 9.41406V7.07812C4.2526 7.18229 3.8776 7.34635 3.55469 7.57031C3.00781 7.95052 2.73438 8.4349 2.73438 9.02344C2.73438 9.3724 2.8125 9.63802 2.96875 9.82031C3.13021 9.9974 3.3099 10.0859 3.50781 10.0859ZM0.40625 9.50781C0.40625 8.78906 0.752604 8.21875 1.44531 7.79688C2.13802 7.375 3.22396 6.95052 4.70312 6.52344V5.35938C4.70312 4.88542 4.60156 4.53646 4.39844 4.3125C4.20052 4.08333 3.84635 3.96875 3.33594 3.96875C3.04948 3.96875 2.8125 4.02344 2.625 4.13281C2.44271 4.23698 2.35156 4.36979 2.35156 4.53125C2.35156 4.59375 2.36198 4.64583 2.38281 4.6875C2.40365 4.72917 2.4349 4.77344 2.47656 4.82031L2.57031 4.92969C2.64323 5.01823 2.70052 5.11719 2.74219 5.22656C2.78906 5.33073 2.8125 5.44271 2.8125 5.5625C2.8125 5.86458 2.71094 6.09896 2.50781 6.26562C2.3099 6.42708 2.07812 6.50781 1.8125 6.50781C1.50521 6.50781 1.24219 6.41667 1.02344 6.23438C0.809896 6.05208 0.703125 5.78906 0.703125 5.44531C0.703125 4.83073 0.992188 4.34375 1.57031 3.98438C2.14844 3.625 2.85938 3.44531 3.70312 3.44531C4.60938 3.44531 5.36719 3.61979 5.97656 3.96875C6.58073 4.32292 6.88281 4.97396 6.88281 5.92188V9.79688C6.88281 9.91146 6.91146 10.0104 6.96875 10.0938C7.03125 10.1719 7.09896 10.2109 7.17188 10.2109C7.23438 10.2109 7.28906 10.2005 7.33594 10.1797C7.38802 10.1536 7.46615 10.0885 7.57031 9.98438L7.8125 10.3203C7.5 10.6849 7.15365 10.9401 6.77344 11.0859C6.53385 11.1797 6.28125 11.2266 6.01562 11.2266C5.54167 11.2266 5.19531 11.0885 4.97656 10.8125C4.85156 10.6562 4.76042 10.4245 4.70312 10.1172C4.26042 10.5599 3.76042 10.8724 3.20312 11.0547C2.86458 11.1693 2.53125 11.2266 2.20312 11.2266C1.76562 11.2266 1.35677 11.0885 0.976562 10.8125C0.596354 10.5312 0.40625 10.0964 0.40625 9.50781Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.3672 9.44531C11.388 9.73698 11.4453 9.97656 11.5391 10.1641C11.7266 10.5286 12.0391 10.7109 12.4766 10.7109C13.0234 10.7109 13.4089 10.4219 13.6328 9.84375C13.862 9.26562 13.9766 8.44792 13.9766 7.39062C13.9766 6.55208 13.875 5.83073 13.6719 5.22656C13.474 4.6224 13.0833 4.32031 12.5 4.32031C12.1562 4.32031 11.8802 4.44792 11.6719 4.70312C11.4688 4.95312 11.3672 5.13281 11.3672 5.24219V9.44531ZM11.3672 0.1875V4.33594C11.6172 4.09115 11.849 3.90625 12.0625 3.78125C12.4531 3.55729 12.875 3.44531 13.3281 3.44531C14.2292 3.44531 14.9531 3.79688 15.5 4.5C16.0521 5.20312 16.3281 6.06771 16.3281 7.09375C16.3281 8.41667 15.9766 9.4375 15.2734 10.1562C14.5755 10.8698 13.7057 11.2266 12.6641 11.2266C12.237 11.2266 11.8594 11.1432 11.5312 10.9766C11.2031 10.8099 10.8958 10.5911 10.6094 10.3203L9.35156 11.2266H9.125V1.5C9.125 1.16667 9.0651 0.942708 8.94531 0.828125C8.82552 0.708333 8.60156 0.625 8.27344 0.578125V0.1875H11.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'lowercase',
                tooltip: 'Lowercase'
              }
            ]"
            :sid="`.--${section.sid}--link`"
            rule-name="text-transform"
          />

          <sid-range-slider
            label="Line Height"
            presudo=":hover"
            rule-name="line-height"
            :sid="`.--${section.sid}--link`"
          />

          <sid-range-slider
            label="Letter Spacing"
            presudo=":hover"
            rule-name="letter-spacing"
            :sid="`.--${section.sid}--link`"
          />

          <sid-background
            label="Link Background Color"
            presudo=":hover"
            :sid="`.--${section.sid}--link`"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Link Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--link`"
                rule-name="border-style"
                :searchable="false"
                presudo=":hover"
                class="w-[118px]"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--link`"
              label="Link Border Width"
              rule-name="border"
              class="!mb-[7px]"
              presudo=":hover"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--link`"
                rule-name="border-color"
                presudo=":hover"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Link Border Radius"
            :sid="`.--${section.sid}--link`"
            rule-name="border"
            presudo=":hover"
            :angles="[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]"
          />

          <sid-linked-group
            label="Link Padding"
            :sid="`.--${section.sid}--link`"
            rule-name="padding"
            :min="0"
            presudo=":hover"
            :angles="[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]"
          />

          <hover-animations
            v-model="hoverAnimation"
            class="mb-0"
          />
        </template>

        <template #Active>
          <sid-font
            :sid="`.--${section.sid}--wrapper`"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Link Color</label>

              <sid-color
                :sid="`.--${section.sid}--link-active`"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex justify-between">
              <label class="pb-0">Icon Color</label>

              <sid-color
                :sid="`.--${section.sid}--link-active .--${section.sid}--icon-active`"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-range-slider
            label="Font Size"
            :sid="`.--${section.sid}--link-active`"
            rule-name="font-size"
          />

          <b-form-group>
            <sid-font-style
              :sid="`.--${section.sid}--link-active`"
              rule-name="font"
            />
          </b-form-group>

          <sid-buttons-group
            label="Alignment"
            :options="[
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'10.04\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 10.04 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'5.54224\' y=\'10.9219\' width=\'3.94211\' height=\'7.30912\' transform=\'rotate(180 5.54224 10.9219)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.5555\' height=\'0.91364\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.913574 14.5557)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'start',
                tooltip: 'Start'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'15\' viewBox=\'0 0 11 15\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect x=\'3.9668\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 3.9668 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'10.4326\' y=\'11.2344\' width=\'3.96671\' height=\'7.35473\' transform=\'rotate(180 10.4326 11.2344)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'14.3631\' height=\'0.901561\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 5.59766 14.363)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'center',
                tooltip: 'Center'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'11\' height=\'16\' viewBox=\'0 0 11 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 0 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'4.1188\' height=\'7.63672\' transform=\'matrix(1 8.74228e-08 8.74228e-08 -1 4.7002 12.2031)\' fill=\'%237E7E7E\'/%3E%3Crect x=\'9.53613\' y=\'16\' width=\'15.2079\' height=\'0.95459\' transform=\'rotate(-90 9.53613 16)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'end',
                tooltip: 'End'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'14\' height=\'13\' viewBox=\'0 0 14 13\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'3.02612\' height=\'8.41616\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 4.4834 2.28711)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'3.02612\' height=\'8.41616\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 11.7031 2.28711)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'11.1734\' height=\'0.701346\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.701172 12.0225)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'11.1734\' height=\'0.701346\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 13.1602 12.0225)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'space-between',
                tooltip: 'Between'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'13\' height=\'14\' viewBox=\'0 0 13 14\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'3.26467\' height=\'9.07958\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 5.48535 2.51978)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'3.26467\' height=\'9.07958\' transform=\'matrix(-1 8.74228e-08 8.66707e-08 1 10.0303 2.51978)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'12.0541\' height=\'0.756631\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 0.756836 13.0225)\' fill=\'%237E7E7E\'/%3E%3Crect width=\'12.0541\' height=\'0.756631\' transform=\'matrix(-4.37114e-08 -1 -1 4.37114e-08 12.25 13.0225)\' fill=\'%237E7E7E\'/%3E%3C/svg%3E%0A',
                value: 'space-around',
                tooltip: 'Around'
              }
            ]"
            :sid="`.--${section.sid}--wrapper`"
            rule-name="justify-content"
          />

          <sid-buttons-group
            label="Text Transform"
            :options="[
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'21\' height=\'12\' viewBox=\'0 0 21 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 8.22656L4.75781 4.52344H4.625L3.17969 8.22656H6.28906ZM0.289062 11.5938C0.674479 11.5677 0.984375 11.3932 1.21875 11.0703C1.36979 10.8672 1.58594 10.4193 1.86719 9.72656L5.42188 0.96875H5.86719L9.4375 9.375C9.83854 10.3177 10.138 10.9271 10.3359 11.2031C10.5339 11.474 10.8151 11.6042 11.1797 11.5938V12H6V11.5938C6.52083 11.5729 6.86198 11.5286 7.02344 11.4609C7.1901 11.3932 7.27344 11.2214 7.27344 10.9453C7.27344 10.8203 7.23177 10.6302 7.14844 10.375C7.09635 10.224 7.02604 10.0417 6.9375 9.82812L6.53125 8.85938H2.9375C2.70312 9.49479 2.55208 9.90885 2.48438 10.1016C2.34375 10.513 2.27344 10.8125 2.27344 11C2.27344 11.2292 2.42708 11.3958 2.73438 11.5C2.91667 11.5573 3.1901 11.5885 3.55469 11.5938V12H0.289062V11.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.2578 11.5938C11.6901 11.5781 12 11.5208 12.1875 11.4219C12.5052 11.2552 12.6641 10.9375 12.6641 10.4688V2.72656C12.6641 2.25781 12.5156 1.94271 12.2188 1.78125C12.0417 1.68229 11.7214 1.61979 11.2578 1.59375V1.1875H16.2031C17.1562 1.1875 17.9479 1.29688 18.5781 1.51562C19.7656 1.92708 20.3594 2.67708 20.3594 3.76562C20.3594 4.42708 20.1172 4.95312 19.6328 5.34375C19.1536 5.72917 18.6328 5.97396 18.0703 6.07812V6.22656C18.6641 6.34115 19.1797 6.53385 19.6172 6.80469C20.4714 7.33594 20.8984 8.07552 20.8984 9.02344C20.8984 9.90885 20.4896 10.6276 19.6719 11.1797C18.8542 11.7266 17.7656 12 16.4062 12H11.2578V11.5938ZM15.2188 6.03906C16.2083 6.03906 16.8724 5.8776 17.2109 5.55469C17.5495 5.23177 17.7188 4.65885 17.7188 3.83594C17.7188 3.22656 17.6068 2.71354 17.3828 2.29688C17.1641 1.88021 16.7396 1.67188 16.1094 1.67188C15.776 1.67188 15.5443 1.72917 15.4141 1.84375C15.2839 1.95312 15.2188 2.15365 15.2188 2.44531V6.03906ZM15.2188 10.5234C15.224 10.8047 15.2656 11.0104 15.3438 11.1406C15.474 11.3698 15.724 11.4844 16.0938 11.4844C16.849 11.4844 17.3776 11.2786 17.6797 10.8672C17.987 10.4557 18.1406 9.86979 18.1406 9.10938C18.1406 7.97396 17.8047 7.21875 17.1328 6.84375C16.7266 6.61458 16.0885 6.50781 15.2188 6.52344V10.5234Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'uppercase',
                tooltip: 'Uppercase'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'20\' height=\'18\' viewBox=\'0 0 20 18\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6.28906 10.2266L4.75781 6.52344H4.625L3.17969 10.2266H6.28906ZM0.289062 13.5938C0.674479 13.5677 0.984375 13.3932 1.21875 13.0703C1.36979 12.8672 1.58594 12.4193 1.86719 11.7266L5.42188 2.96875H5.86719L9.4375 11.375C9.83854 12.3177 10.138 12.9271 10.3359 13.2031C10.5339 13.474 10.8151 13.6042 11.1797 13.5938V14H6V13.5938C6.52083 13.5729 6.86198 13.5286 7.02344 13.4609C7.1901 13.3932 7.27344 13.2214 7.27344 12.9453C7.27344 12.8203 7.23177 12.6302 7.14844 12.375C7.09635 12.224 7.02604 12.0417 6.9375 11.8281L6.53125 10.8594H2.9375C2.70312 11.4948 2.55208 11.9089 2.48438 12.1016C2.34375 12.513 2.27344 12.8125 2.27344 13C2.27344 13.2292 2.42708 13.3958 2.73438 13.5C2.91667 13.5573 3.1901 13.5885 3.55469 13.5938V14H0.289062V13.5938Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M14.3672 12.4453C14.388 12.737 14.4453 12.9766 14.5391 13.1641C14.7266 13.5286 15.0391 13.7109 15.4766 13.7109C16.0234 13.7109 16.4089 13.4219 16.6328 12.8438C16.862 12.2656 16.9766 11.4479 16.9766 10.3906C16.9766 9.55208 16.875 8.83073 16.6719 8.22656C16.474 7.6224 16.0833 7.32031 15.5 7.32031C15.1562 7.32031 14.8802 7.44792 14.6719 7.70312C14.4688 7.95312 14.3672 8.13281 14.3672 8.24219V12.4453ZM14.3672 3.1875V7.33594C14.6172 7.09115 14.849 6.90625 15.0625 6.78125C15.4531 6.55729 15.875 6.44531 16.3281 6.44531C17.2292 6.44531 17.9531 6.79688 18.5 7.5C19.0521 8.20312 19.3281 9.06771 19.3281 10.0938C19.3281 11.4167 18.9766 12.4375 18.2734 13.1562C17.5755 13.8698 16.7057 14.2266 15.6641 14.2266C15.237 14.2266 14.8594 14.1432 14.5312 13.9766C14.2031 13.8099 13.8958 13.5911 13.6094 13.3203L12.3516 14.2266H12.125V4.5C12.125 4.16667 12.0651 3.94271 11.9453 3.82812C11.8255 3.70833 11.6016 3.625 11.2734 3.57812V3.1875H14.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'capitalize',
                tooltip: 'Capitalize'
              },
              {
                svg: 'data:image/svg+xml,%3Csvg width=\'17\' height=\'12\' viewBox=\'0 0 17 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M3.50781 10.0859C3.76823 10.0859 4.01042 10.0078 4.23438 9.85156C4.35938 9.75781 4.50781 9.61198 4.67969 9.41406V7.07812C4.2526 7.18229 3.8776 7.34635 3.55469 7.57031C3.00781 7.95052 2.73438 8.4349 2.73438 9.02344C2.73438 9.3724 2.8125 9.63802 2.96875 9.82031C3.13021 9.9974 3.3099 10.0859 3.50781 10.0859ZM0.40625 9.50781C0.40625 8.78906 0.752604 8.21875 1.44531 7.79688C2.13802 7.375 3.22396 6.95052 4.70312 6.52344V5.35938C4.70312 4.88542 4.60156 4.53646 4.39844 4.3125C4.20052 4.08333 3.84635 3.96875 3.33594 3.96875C3.04948 3.96875 2.8125 4.02344 2.625 4.13281C2.44271 4.23698 2.35156 4.36979 2.35156 4.53125C2.35156 4.59375 2.36198 4.64583 2.38281 4.6875C2.40365 4.72917 2.4349 4.77344 2.47656 4.82031L2.57031 4.92969C2.64323 5.01823 2.70052 5.11719 2.74219 5.22656C2.78906 5.33073 2.8125 5.44271 2.8125 5.5625C2.8125 5.86458 2.71094 6.09896 2.50781 6.26562C2.3099 6.42708 2.07812 6.50781 1.8125 6.50781C1.50521 6.50781 1.24219 6.41667 1.02344 6.23438C0.809896 6.05208 0.703125 5.78906 0.703125 5.44531C0.703125 4.83073 0.992188 4.34375 1.57031 3.98438C2.14844 3.625 2.85938 3.44531 3.70312 3.44531C4.60938 3.44531 5.36719 3.61979 5.97656 3.96875C6.58073 4.32292 6.88281 4.97396 6.88281 5.92188V9.79688C6.88281 9.91146 6.91146 10.0104 6.96875 10.0938C7.03125 10.1719 7.09896 10.2109 7.17188 10.2109C7.23438 10.2109 7.28906 10.2005 7.33594 10.1797C7.38802 10.1536 7.46615 10.0885 7.57031 9.98438L7.8125 10.3203C7.5 10.6849 7.15365 10.9401 6.77344 11.0859C6.53385 11.1797 6.28125 11.2266 6.01562 11.2266C5.54167 11.2266 5.19531 11.0885 4.97656 10.8125C4.85156 10.6562 4.76042 10.4245 4.70312 10.1172C4.26042 10.5599 3.76042 10.8724 3.20312 11.0547C2.86458 11.1693 2.53125 11.2266 2.20312 11.2266C1.76562 11.2266 1.35677 11.0885 0.976562 10.8125C0.596354 10.5312 0.40625 10.0964 0.40625 9.50781Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3Cpath d=\'M11.3672 9.44531C11.388 9.73698 11.4453 9.97656 11.5391 10.1641C11.7266 10.5286 12.0391 10.7109 12.4766 10.7109C13.0234 10.7109 13.4089 10.4219 13.6328 9.84375C13.862 9.26562 13.9766 8.44792 13.9766 7.39062C13.9766 6.55208 13.875 5.83073 13.6719 5.22656C13.474 4.6224 13.0833 4.32031 12.5 4.32031C12.1562 4.32031 11.8802 4.44792 11.6719 4.70312C11.4688 4.95312 11.3672 5.13281 11.3672 5.24219V9.44531ZM11.3672 0.1875V4.33594C11.6172 4.09115 11.849 3.90625 12.0625 3.78125C12.4531 3.55729 12.875 3.44531 13.3281 3.44531C14.2292 3.44531 14.9531 3.79688 15.5 4.5C16.0521 5.20312 16.3281 6.06771 16.3281 7.09375C16.3281 8.41667 15.9766 9.4375 15.2734 10.1562C14.5755 10.8698 13.7057 11.2266 12.6641 11.2266C12.237 11.2266 11.8594 11.1432 11.5312 10.9766C11.2031 10.8099 10.8958 10.5911 10.6094 10.3203L9.35156 11.2266H9.125V1.5C9.125 1.16667 9.0651 0.942708 8.94531 0.828125C8.82552 0.708333 8.60156 0.625 8.27344 0.578125V0.1875H11.3672Z\' fill=\'%23AEB1B4\'%3E%3C/path%3E%3C/svg%3E',
                value: 'lowercase',
                tooltip: 'Lowercase'
              }
            ]"
            :sid="`.--${section.sid}--link-active`"
            rule-name="text-transform"
          />

          <sid-range-slider
            label="Line Height"
            rule-name="line-height"
            :sid="`.--${section.sid}--link-active`"
          />

          <sid-range-slider
            label="Letter Spacing"
            rule-name="letter-spacing"
            :sid="`.--${section.sid}--link-active`"
          />

          <sid-range-slider
            label="Gap"
            rule-name="gap"
            :sid="`.--${section.sid}--wrapper`"
          />

          <sid-background
            :sid="`.--${section.sid}--wrapper`"
          />

          <sid-background
            label="Link Background Color"
            :sid="`.--${section.sid}--link-active`"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Link Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--link-active`"
                rule-name="border-style"
                :searchable="false"
                class="w-[118px]"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--link-active`"
              label="Link Border Width"
              rule-name="border"
              class="!mb-[7px]"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--link-active`"
                rule-name="border-color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Link Border Radius"
            :sid="`.--${section.sid}--link-active`"
            rule-name="border"
            :angles="[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]"
          />

          <sid-linked-group
            label="Link Padding"
            :sid="`.--${section.sid}--link-active`"
            rule-name="padding"
            :min="0"
            :angles="[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]"
          />
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup title="Link Transform">
      <rule-tabs :tabs="['Normal', 'Hover', 'Active']">
        <template #Normal>
          <b-form-group>
            <sid-transform
              :sid="`.--${section.sid}--link`"
              rule-name="transform"
              :section="section"
            />
          </b-form-group>
        </template>
        <template #Hover>
          <b-form-group>
            <sid-transform
              :sid="`.--${section.sid}--link`"
              presudo=":hover"
              rule-name="transform"
              :section="section"
            />
          </b-form-group>
        </template>
        <template #Active>
          <b-form-group>
            <sid-transform
              :sid="`.--${section.sid}--link.active`"
              rule-name="transform"
              :section="section"
            />
          </b-form-group>
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup title="Dropdown Area">
      <sid-width-and-height
        :sid="`.--${section.sid}--dropdown-menu`"
      />

      <sid-background
        label="Dropdown Background Color"
        :sid="`.--${section.sid}--dropdown-menu`"
      />

      <sid-range-slider
        rule-name="gap"
        :sid="`.--${section.sid}--dropdown-menu`"
        default-value="px"
        :dimensions="[]"
        label="Gap"
      />

      <sid-linked-group
        label="Padding"
        :sid="`.--${section.sid}--dropdown-menu`"
        rule-name="padding"
        :min="0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />

      <b-form-group>
        <div class="flex items-center justify-between">
          <label class="pb-0">Border Type</label>

          <sid-select
            :sid="`.--${section.sid}--dropdown-menu`"
            rule-name="border-style"
            :searchable="false"
            class="w-[118px]"
            :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
          />
        </div>
      </b-form-group>

      <b-form-group>
        <sid-linked-group
          :sid="`.--${section.sid}--dropdown-menu`"
          label="Border Width"
          rule-name="border"
          class="!mb-[7px]"
          :angles="[
            {
              text: '',
              value: 'top-width'
            },
            {
              text: '',
              value: 'right-width'
            },
            {
              text: '',
              value: 'bottom-width'
            },
            {
              text: '',
              value: 'left-width'
            }
          ]"
        />

        <div class="flex w-full justify-end">
          <sid-color
            :sid="`.--${section.sid}--dropdown-menu`"
            rule-name="border-color"
            allow-reset
          />
        </div>
      </b-form-group>

      <sid-linked-group
        label="Radius"
        :sid="`.--${section.sid}--dropdown-menu`"
        rule-name="border"
        :angles="[
          {
            text: '',
            value: 'top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius'
          }
        ]"
      />

      <b-form-group
        label="Shadow Color"
        class="mb-0"
      >
        <sid-box-shadow
          :sid="`.--${section.sid}--dropdown-menu`"
          rule-name="box-shadow"
        />
      </b-form-group>

      <b-form-group
        label="Dropdown Position"
        class="mb-0"
      >
        <v-select
          v-model="dropdownPlacement"
          :options="dropdownPlacementOptions"
          :searchable="false"
          :reduce="val => val.value"
        />
      </b-form-group>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup title="Dropdown Item Area">
      <rule-tabs>
        <template #Normal>
          <sid-background
            label="Dropdown Link Background Color"
            :sid="`.--${section.sid}--dropdown-link`"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Dropdown Link Color</label>

              <sid-color
                :sid="`.--${section.sid}--dropdown-link`"
                rule-name="color"
                allow-reset
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="p-0">Text Alignment</label>
              <sid-buttons-group
                class="mb-0"
                :options="[
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'16\' height=\'16\' viewBox=\'0 0 16 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'%3E%3Crect x=\'0.475586\' y=\'0.475464\' width=\'14.9508\' height=\'14.9508\' fill=\'url(%23pattern0)\'/%3E%3Cdefs%3E%3Cpattern id=\'pattern0\' patternContentUnits=\'objectBoundingBox\' width=\'1\' height=\'1\'%3E%3Cuse xlink:href=\'%23image0_7786_57178\' transform=\'scale(0.00195312)\'/%3E%3C/pattern%3E%3Cimage id=\'image0_7786_57178\' width=\'512\' height=\'512\' xlink:href=\'data:image/png;base64,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\'/%3E%3C/defs%3E%3C/svg%3E%0A',
                    value: 'start',
                    tooltip: 'Left'
                  },
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'18\' height=\'14\' viewBox=\'0 0 18 14\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'%3E%3Crect x=\'0.951172\' y=\'0.431396\' width=\'16.5246\' height=\'13.0389\' fill=\'url(%23pattern0)\'/%3E%3Cdefs%3E%3Cpattern id=\'pattern0\' patternContentUnits=\'objectBoundingBox\' width=\'1\' height=\'1\'%3E%3Cuse xlink:href=\'%23image0_7786_57177\' transform=\'scale(0.00195312 0.00247525)\'/%3E%3C/pattern%3E%3Cimage id=\'image0_7786_57177\' width=\'512\' height=\'404\' xlink:href=\'data:image/png;base64,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\'/%3E%3C/defs%3E%3C/svg%3E%0A',
                    value: 'center',
                    tooltip: 'Center'
                  },
                  {
                    svg: 'data:image/svg+xml,%3Csvg width=\'15\' height=\'16\' viewBox=\'0 0 15 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\'%3E%3Crect x=\'14.9512\' y=\'15.4263\' width=\'14.9508\' height=\'14.9508\' transform=\'rotate(180 14.9512 15.4263)\' fill=\'url(%23pattern0)\'/%3E%3Cdefs%3E%3Cpattern id=\'pattern0\' patternContentUnits=\'objectBoundingBox\' width=\'1\' height=\'1\'%3E%3Cuse xlink:href=\'%23image0_7786_57179\' transform=\'scale(0.00195312)\'/%3E%3C/pattern%3E%3Cimage id=\'image0_7786_57179\' width=\'512\' height=\'512\' xlink:href=\'data:image/png;base64,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\'/%3E%3C/defs%3E%3C/svg%3E%0A',
                    value: 'end',
                    tooltip: 'Right'
                  }
                ]"
                :sid="`.--${section.sid}--dropdown-link > div`"
                rule-name="justify-content"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Border Type</label>

              <sid-select
                :sid="`.--${section.sid}--dropdown-link`"
                rule-name="border-style"
                :searchable="false"
                class="w-[118px]"
                :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <sid-linked-group
              :sid="`.--${section.sid}--dropdown-link`"
              label="Border Width"
              rule-name="border"
              class="!mb-[7px]"
              :angles="[
                {
                  text: '',
                  value: 'top-width'
                },
                {
                  text: '',
                  value: 'right-width'
                },
                {
                  text: '',
                  value: 'bottom-width'
                },
                {
                  text: '',
                  value: 'left-width'
                }
              ]"
            />

            <div class="flex w-full justify-end">
              <sid-color
                :sid="`.--${section.sid}--dropdown-link`"
                rule-name="border-color"
                allow-reset
              />
            </div>
          </b-form-group>

          <sid-linked-group
            label="Radius"
            :sid="`.--${section.sid}--dropdown-link`"
            rule-name="border"
            :angles="[
              {
                text: '',
                value: 'top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius'
              }
            ]"
          />

          <sid-linked-group
            label="Padding"
            :sid="`.--${section.sid}--dropdown-link`"
            rule-name="padding"
            :min="0"
            :angles="[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]"
          />
        </template>

        <template #Hover>
          <sid-background
            label="Dropdown Link Background Color"
            :sid="`.--${section.sid}--dropdown-link`"
            presudo=":hover"
          />

          <b-form-group>
            <div class="flex items-center justify-between">
              <label class="pb-0">Dropdown Link Color</label>

              <sid-color
                :sid="`.--${section.sid}--dropdown-link`"
                rule-name="color"
                presudo=":hover"
                allow-reset
              />
            </div>
          </b-form-group>
        </template>
      </rule-tabs>
    </SidbearSettingsGroup>

    <SidbearSettingsGroup title="Border & Radius">
      <b-form-group>
        <div class="flex items-center justify-between">
          <label class="pb-0">Border Type</label>

          <sid-select
            :sid="`.--${section.sid}--wrapper`"
            rule-name="border-style"
            :searchable="false"
            class="w-[118px]"
            :options="[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]"
          />
        </div>
      </b-form-group>

      <b-form-group>
        <sid-linked-group
          :sid="`.--${section.sid}--wrapper`"
          label="Border Width"
          rule-name="border"
          class="!mb-[7px]"
          :angles="[
            {
              text: '',
              value: 'top-width'
            },
            {
              text: '',
              value: 'right-width'
            },
            {
              text: '',
              value: 'bottom-width'
            },
            {
              text: '',
              value: 'left-width'
            }
          ]"
        />

        <div class="flex w-full justify-end">
          <sid-color
            :sid="`.--${section.sid}--wrapper`"
            rule-name="border-color"
            allow-reset
          />
        </div>
      </b-form-group>

      <sid-linked-group
        label="Radius"
        :sid="`.--${section.sid}--wrapper`"
        rule-name="border"
        :angles="[
          {
            text: '',
            value: 'top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius'
          }
        ]"
      />
    </SidbearSettingsGroup>

    <SidbearSettingsGroup
      title="Padding & Margins"
    >
      <sid-linked-group
        label="Padding"
        :sid="`.--${section.sid}--wrapper`"
        rule-name="padding"
        :min="0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />
      <sid-linked-group
        label="Margin"
        :sid="`.--${section.sid}--wrapper`"
        rule-name="margin"
        :min="-2000"
        :max="2000"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />
    </SidbearSettingsGroup>

    <link-modal
      v-model="newListItemModal"
      :config="menu"
    />

    <links-navigation-modal
      v-model="navigationModal"
      :config="menu"
    >
      <b-btn
        class="btn-wide"
        variant="primary"
        @click="addLink"
      >
        Add Item
      </b-btn>
    </links-navigation-modal>
  </div>
</template>

<script>
import ModMixin from '@/components/mixins/ModMixin'
import RuleTabs from '@/components/editor/components/RuleTabs'
import SidFont from '@/components/editor/components/sid-controls/sid-control-pressets/font/SidFont'
import SidRangeSlider from '@/components/editor/components/sid-controls/SidRangeSlider'
import SidColor from '@/components/editor/components/sid-controls/SidColor'
import SidFontStyle from '@/components/editor/components/sid-controls/SidFontStyle'
import SidButtonsGroup from '@/components/editor/components/sid-controls/SidButtonsGroup'
import SidBackground
  from '@/components/editor/components/sid-controls/sid-control-pressets/background-color/SidBackground'
import _ from 'lodash'
import SidbearSettingsGroup from '@/components/editor/components/SidbearSettingsGroup'
import SidLinkedGroup from '@/components/editor/components/sid-controls/SidLinkedGroup'
import SidSelect from '@/components/editor/components/sid-controls/SidSelect'
import SidBoxShadow from '@/components/editor/components/sid-controls/sid-control-pressets/box-shadow/SidBoxShadow'
import LinksNavigationModal from '@/components/editor/controls/menu-links-mod/LinksNavigationModal'
import LinkModal from '@/components/editor/controls/menu-links-mod/LinkModal'
import SidTransform from '@/components/editor/components/sid-controls/sid-control-pressets/transform/SidTransform'
import SidFlexDirection from '@/components/editor/components/sid-controls/sid-control-pressets/flex/SidFlexDirection'
import SidWidthAndHeight from '@/components/editor/components/sid-controls/sid-control-pressets/SidWidthAndHeight'
import HoverAnimations from '@/components/editor/controls/HoverAnimations'

export default {
  name: 'MenuLinksModV4',
  components: {
    HoverAnimations,
    SidWidthAndHeight,
    SidFlexDirection,
    SidTransform,
    LinkModal,
    LinksNavigationModal,
    SidBoxShadow,
    SidSelect,
    SidLinkedGroup,
    SidbearSettingsGroup,
    SidBackground, SidButtonsGroup, SidFontStyle, SidColor, SidRangeSlider, SidFont, RuleTabs},
  mixins: [ModMixin],
  data () {
    return {
      navigationModal: false,
      newListItemModal: false,
      dropdownPlacementOptions: [
        {
          label: 'Top',
          value: 'top'
        },
        {
          label: 'Top Start',
          value: 'top-start'
        },
        {
          label: 'Top End',
          value: 'top-end'
        },
        {
          label: 'Bottom',
          value: 'bottom'
        },
        {
          label: 'Bottom Start',
          value: 'bottom-start'
        },
        {
          label: 'Bottom End',
          value: 'bottom-end'
        },
        {
          label: 'Right',
          value: 'right'
        },
        {
          label: 'Right Start',
          value: 'right-start'
        },
        {
          label: 'Right End',
          value: 'right-end'
        },
        {
          label: 'Left',
          value: 'left'
        },
        {
          label: 'Left Start',
          value: 'left-start'
        },
        {
          label: 'Left End',
          value: 'left-end'
        }
      ]
    }
  },
  computed: {
    menu () {
      return this.section.options.content.menu
    },
    dropdownPlacement: {
      get () {
        return _.get(this.section.options.content.menu, ['dropdownPlacement', this.resolutioner], _.get(this.section.options.content.menu, ['dropdownPlacement', 'lg'], 'bottom-start'))
      },
      set (val) {
        this.$set(this.section.options.content.menu, 'dropdownPlacement', {..._.set(this.section.options.content.menu.dropdownPlacement || {}, [this.resolutioner], val)})
      }
    },
    hoverAnimation: {
      get () {
        return this.config.hoverAnimation || null
      },
      set (val) {
        this.$set(this.config, 'hoverAnimation', val)
      }
    }
  },
  methods: {
    addLink () {
      this.newListItemModal = true
    }
  }
}
</script>